import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/server')({
  component: () => <Navigate to="/admin/dashboard" replace />,
})